/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * ユーザーが持つミッション情報を管理するためのモデル
 * @export
 * @interface UserMissionItemModel
 */
export interface UserMissionItemModel {
    /**
     * ミッションタイトル
     * @type {string}
     * @memberof UserMissionItemModel
     */
    title?: string;
    /**
     * ミッション期限(UNIX時間)
     * @type {number}
     * @memberof UserMissionItemModel
     */
    endDate?: number;
    /**
     * 達成回数(進捗度)
     * @type {number}
     * @memberof UserMissionItemModel
     */
    achievementCount?: number;
    /**
     * 達成目標数(達成するために必要な回数)
     * @type {number}
     * @memberof UserMissionItemModel
     */
    targetAchievementCount?: number;
    /**
     * 達成されたミッションであるかを示すフラグ　＊true：達成済み　＊false：未達成
     * @type {boolean}
     * @memberof UserMissionItemModel
     */
    isAchieved?: boolean;
    /**
     * 達成日時(UNIX時間)
     * @type {number}
     * @memberof UserMissionItemModel
     */
    achievedDate?: number;
    /**
     * ミッションの状態が失敗かどうかの値　＊0：進行中　＊1：失敗
     * @type {number}
     * @memberof UserMissionItemModel
     */
    status?: number;
    /**
     * ミッションのプロモーションID (コンテンツミッションプロモーションテーブルのレコードID)
     * この値が`3`の場合、「3作品シェアする」ミッションに該当するため、フロント側ではシェアボタン確認用のページリンクを表示する必要があります。
     * @type {number}
     * @memberof UserMissionItemModel
     */
    promotionId?: number;
    /**
     * 達成時に得られるチケット枚数
     * @type {number}
     * @memberof UserMissionItemModel
     */
    rewardTicketNumber?: number;
    /**
     * ミッションのリンク先
     * @type {string}
     * @memberof UserMissionItemModel
     */
    linkDestination?: string;
}

/**
 * Check if a given object implements the UserMissionItemModel interface.
 */
export function instanceOfUserMissionItemModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UserMissionItemModelFromJSON(json: any): UserMissionItemModel {
    return UserMissionItemModelFromJSONTyped(json, false);
}

export function UserMissionItemModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserMissionItemModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': !exists(json, 'title') ? undefined : json['title'],
        'endDate': !exists(json, 'endDate') ? undefined : json['endDate'],
        'achievementCount': !exists(json, 'achievementCount') ? undefined : json['achievementCount'],
        'targetAchievementCount': !exists(json, 'targetAchievementCount') ? undefined : json['targetAchievementCount'],
        'isAchieved': !exists(json, 'isAchieved') ? undefined : json['isAchieved'],
        'achievedDate': !exists(json, 'achievedDate') ? undefined : json['achievedDate'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'promotionId': !exists(json, 'promotionId') ? undefined : json['promotionId'],
        'rewardTicketNumber': !exists(json, 'rewardTicketNumber') ? undefined : json['rewardTicketNumber'],
        'linkDestination': !exists(json, 'linkDestination') ? undefined : json['linkDestination'],
    };
}

export function UserMissionItemModelToJSON(value?: UserMissionItemModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title,
        'endDate': value.endDate,
        'achievementCount': value.achievementCount,
        'targetAchievementCount': value.targetAchievementCount,
        'isAchieved': value.isAchieved,
        'achievedDate': value.achievedDate,
        'status': value.status,
        'promotionId': value.promotionId,
        'rewardTicketNumber': value.rewardTicketNumber,
        'linkDestination': value.linkDestination,
    };
}

